import BaseApi from "./_base-api";

/**
 * FAQ API
 *
 * @class Api
 * @extends {BaseApi}
 */
class Api extends BaseApi {}

const api = new Api({
	type: "FAQ",
	path: "faqs"
});

export default api;
